import IAmount from "../IAmount";
import ISettingsCashLoan from "./ISettingsCashLoan";

export default class SettingsCashLoan implements ISettingsCashLoan {
    public preferredInstallment?: IAmount;
    public productCode?: string;

    constructor(preferredInstallment?: IAmount, productCode?: string) {
        this.preferredInstallment = preferredInstallment;
        this.productCode = productCode;
    }
}